import {
  MEMBERS_ADD_PAGE_TYPE,
  MEMBERS_GET_INITIAL_PAGE_TYPE,
  MEMBERS_GET_PAGE_TYPE,
  MEMBERS_INITIALIZE_TYPE,
  MEMBERS_REMOVE_ACCOUNT,
  MEMBERS_REMOVE_ACCOUNT_ERROR,
  MEMBERS_REMOVE_ACCOUNT_MEMBERSHIP,
  MEMBERS_REMOVE_ACCOUNT_SUCCESS,
  MEMBERS_REMOVE_ACCOUNTS_SUCCESS,
  MEMBERS_RESET_RESULTS_TYPE,
  MEMBERS_RESET_STATE_TYPE,
  MEMBERS_SET_ADMIN_MODE,
  MEMBERS_SET_CURRENT_PAGE_TYPE,
  MEMBERS_SET_VIEW_MODE,
  MEMBERS_UPDATE_ACCOUNT,
  MEMBERS_UPDATE_SEARCH_PARAMS_TYPE,
  MembersAction,
} from './members.actions';
import {
  DEFAULT_GET_PARAMS,
  MembersState,
  VIEW_MODES,
} from './members.interfaces';

import { Account } from '../models/account.model';

import chunk from 'lodash-es/chunk';
import cloneDeep from 'lodash-es/cloneDeep';
import compact from 'lodash-es/compact';
import flatten from 'lodash-es/flatten';
import isEqual from 'lodash-es/isEqual';
import remove from 'lodash-es/remove';
import set from 'lodash-es/set';

const INITIAL_STATE: MembersState = {
  accounts: [],
  currentPage: 0,
  isAdminMode: false,
  isFetching: false,
  isInitialized: false,
  searchParams: {},
  totalCount: 0,
  viewMode: VIEW_MODES.cards,
};

export function membersReducer(
  state: any = INITIAL_STATE,
  action: MembersAction,
): MembersState {
  switch (action.type) {
    case MEMBERS_ADD_PAGE_TYPE: {
      const clonedAccountsToAdd = cloneDeep(state.accounts);
      clonedAccountsToAdd[action.payload.pageIndex] = compact(
        action.payload.accounts,
      );
      return {
        ...state,
        accounts: clonedAccountsToAdd,
        isFetching: false,
        totalCount: action.payload.count || 0,
      };
    }

    case MEMBERS_GET_INITIAL_PAGE_TYPE: {
      return {
        ...state,
        searchParams: action.payload.searchParams,
      };
    }

    case MEMBERS_GET_PAGE_TYPE: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MEMBERS_INITIALIZE_TYPE: {
      return {
        ...state,
        accounts: [compact(action.payload.accounts)],
        currentPage: 0,
        isInitialized: true,
        totalCount: action.payload.count,
      };
    }

    case MEMBERS_SET_CURRENT_PAGE_TYPE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }

    case MEMBERS_UPDATE_SEARCH_PARAMS_TYPE: {
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.payload,
        },
      };
    }

    case MEMBERS_UPDATE_ACCOUNT: {
      return {
        ...state,
        accounts: set(
          cloneDeep(state.accounts),
          [action.payload.pageIndex, action.payload.itemIndex],
          action.payload.account,
        ),
      };
    }

    case MEMBERS_RESET_RESULTS_TYPE: {
      return {
        ...state,
        accounts: [],
        currentPage: 0,
        isFetching: false,
        totalCount: 0,
      };
    }
    case MEMBERS_RESET_STATE_TYPE: {
      return INITIAL_STATE;
    }

    case MEMBERS_SET_VIEW_MODE: {
      return {
        ...state,
        viewMode: action.payload,
      };
    }

    case MEMBERS_REMOVE_ACCOUNT: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case MEMBERS_REMOVE_ACCOUNT_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }

    case MEMBERS_REMOVE_ACCOUNT_SUCCESS: {
      const clonedAccounts = flatten(cloneDeep(state.accounts));
      remove(clonedAccounts, (account: Account) =>
        isEqual(account._id, action.payload._id),
      );
      const updatedAccountPages = chunk(
        clonedAccounts,
        DEFAULT_GET_PARAMS.limit,
      );
      return {
        ...state,
        accounts: updatedAccountPages,
        isFetching: false,
        totalCount: state.totalCount - 1,
      };
    }

    case MEMBERS_REMOVE_ACCOUNTS_SUCCESS: {
      const accountsClone = flatten(cloneDeep(state.accounts));
      const emails = action.payload.emails;
      remove(accountsClone, (account: Account) =>
        emails.includes(account.email),
      );
      const updatedPages = chunk(accountsClone, DEFAULT_GET_PARAMS.limit);
      return {
        ...state,
        accounts: updatedPages,
        isFetching: false,
        totalCount: accountsClone.length,
      };
    }

    case MEMBERS_SET_ADMIN_MODE: {
      return {
        ...state,
        isAdminMode: action.payload,
      };
    }

    case MEMBERS_REMOVE_ACCOUNT_MEMBERSHIP: {
      const clonedAccounts = flatten(cloneDeep(state.accounts));
      remove(clonedAccounts, (account: Account) =>
        isEqual(account._id, action.payload._id),
      );
      const updatedAccountPages = chunk(
        clonedAccounts,
        DEFAULT_GET_PARAMS.limit,
      );
      return {
        ...state,
        accounts: updatedAccountPages,
        totalCount: state.totalCount - 1,
      };
    }

    default: {
      return state;
    }
  }
}
